import { render, staticRenderFns } from "./pbi-after-sales.page.vue?vue&type=template&id=19d7eda5"
import script from "./pbi-after-sales.page.vue?vue&type=script&lang=ts"
export * from "./pbi-after-sales.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports